


/***************** Init Head ******************/


function pageHeaderInit() {
  if (Foundation.MediaQuery.atLeast('large') && $('#header-outer').length) {
    if ($('.logo-desktop').length) {
      var logoHeight = $('.logo-desktop').data('height-default');
      $('.logo-desktop').css('max-height', logoHeight +'px');
    }
    contentMarginTop();
        /*if ($('#nav-tabs').length) {
          console.log('logoHeight:' + logoHeight);
          // Do nothing - we've disabled hide-until-needed menu on pages with nav-tabs
          contentElem.css('margin-top','0');
        } else {
          console.log('logoHeight:' + logoHeight);
          contentElem.css('margin-top',pageHeaderHeight + 'px');
          contentElem.css('margin-top',pageHeaderHeight + 'px');
        }*/
  } else if (Foundation.MediaQuery.atLeast('mediumx') && $('#header-outer').length) {
    if ($('.logo-desktop').length) {
      var logoHeight = $('.logo-desktop').data('height-medium');
      $('.logo-desktop').css('max-height', logoHeight +'px');
    }
    setTimeout( function() {
      contentMarginTop();
    }, 500);  // Add delay of 300ms before getting and setting to allow for header change to finish

  } else if (Foundation.MediaQuery.atLeast('medium') && $('#header-outer').length) {
    if ($('.logo-desktop').length) {
      var logoHeight = $('.logo-desktop').data('height-medium');
      $('.logo-desktop').css('max-height', logoHeight +'px');
    }
    setTimeout( function() {
      contentMarginTop();
    }, 500);  // Add delay of 300ms before getting and setting to allow for header change to finish
  } else if ($('#header-outer').length) {
    if ($('.logo-desktop').length) {
      var logoHeight = $('.logo-desktop').data('height-small');
      $('.logo-desktop').css('max-height', logoHeight +'px');
    }
    contentMarginTop();
  }
  $('#logo-link').addClass('active');
}

function contentMarginTop() {
  var headerHideUntilNeeded = $('body').attr('data-headed-needed');
  if ($('#header-outer').length && !$('body.home').length && !$('body.page-template-template-account-homepage').length) {
    var contentElem = $('#content');
    if (Foundation.MediaQuery.atLeast('large')) {
      var pageHeaderHeight = $('#header-outer').outerHeight(true) + 20;
    } else {
      var pageHeaderHeight = $('#header-outer').outerHeight(true);
    }
    contentElem.css('margin-top',pageHeaderHeight + 'px');
    $('#inner-content').addClass('ready');
  } else if ($('#header-outer').length) {
    var pageHeaderHeight = $('#header-outer').outerHeight(true);
    $('.header-space').css('padding-top',pageHeaderHeight + 'px');
    $('#inner-content').addClass('ready');
  } else {
  //  var contentElem = $('#content');
  //  contentElem.css('margin-top','0');
    $('#inner-content').addClass('ready');
  }
}

function getHeaderHeight() {
  var hhreturn = $('#header-outer').outerHeight(true);
  return hhreturn;
}

function remainingHeight() {
  if ($('.remaining-height').length) {
    setTimeout( function() {
      var pageHeaderHeight = getHeaderHeight();
      var windowHeight = $(window).height();
      console.log('windowHeight: ' + windowHeight + ' pageHeaderHeight: ' + pageHeaderHeight);
      if (Foundation.MediaQuery.atLeast('large')) {
        var remainingHeight = windowHeight - pageHeaderHeight - 40; // Remove 40px for borders
        $('.remaining-height').css('height',remainingHeight + 'px');
      } else {
        var remainingHeight = windowHeight - pageHeaderHeight; // Remove 40px for borders
        $('.remaining-height-small').css('height',remainingHeight + 'px');
      }
    }, 500);

  }
}

/***************** Add Top padding to all full height panels ******************/

var headerHeight;
function panelTopPadding() {
  headerHeight = getHeaderHeight();
  console.log('headerHeight' + headerHeight);
  if (Foundation.MediaQuery.atLeast('large') && $('.panel.vh100').length) {
    $( ".panel.vh100" ).each(function( index ) {
      if (index>0) { // Ignore first panel
        $(this).css('padding-top', headerHeight + 'px');
      }
    });
  }
}

function positionSearchBar() {
  var this_header_height = getHeaderHeight();
  var searchIconPosition = $('.search-toggle').position();
  var searchIconLeft = searchIconPosition.left;
  console.log('searchIconLeft: ' + searchIconLeft);
  $('.header-search-form-wrapper').css({
    'top':this_header_height/2 + 'px',
    'left': searchIconLeft + 'px'
  });
}


/***************** Shrink Nav Stuff ******************/

function smallNav() {
  var $offset = $(window).scrollTop();
  var headerElemResize = $('#header-outer').data('header-resize');
  if ($offset > 0 && Foundation.MediaQuery.atLeast('mediumx') && $('#page-header-wrapper').length && headerElemResize=='1') {
    var defaultPadding = $('#header-nav-wrapper').data('padding');
    var shrunkPadding = $('#header-nav-wrapper').data('padding-shrunk');
    var shrunkLogoPercentage = $('#header-nav-wrapper').data('logo-shrink')/100;
    var defaultLogoHeight = $('.logo-desktop').data('height-default');
    var newLogoHeight = defaultLogoHeight * shrunkLogoPercentage;
    $('.logo-desktop').css ('height', newLogoHeight + 'px');
    $('#header-nav-wrapper').css ('padding', shrunkPadding + 'px 0');
    $('#header-nav-wrapper').addClass('smallnav');
    $(window).on('scroll', bigNav);
    $(window).off('scroll', smallNav);
  }
}

function bigNav () {
  var $offset = $(window).scrollTop();
  if ($offset <= 0 && Foundation.MediaQuery.atLeast('mediumx') && $('#page-header-wrapper').length) {
    var defaultPadding = $('#header-nav-wrapper').data('padding');
    var defaultLogoHeight = $('.logo-desktop').data('height-default');
    $('.logo-desktop').css ('height', defaultLogoHeight + 'px');
    $('#header-nav-wrapper').css ('padding', defaultPadding + 'px 0');
    $('#header-nav-wrapper').removeClass('smallnav');
    $(window).off('scroll', bigNav);
    $(window).on('scroll', smallNav);
  }
}

/***************** Header Text Stuff ******************/

function pageHeaderTextInit() {
  if (Foundation.MediaQuery.atLeast('medium') && $('#page-header-wrapper').length) {
    var pageHeaderHeight = $('#page-header-wrapper').height();
    var pageHeadingHeight = $('#header-text').height();
    var initTopCalc = ((pageHeaderHeight/2)) - ((pageHeaderHeight/100)*10) +"px";
      $('#header-text').css({
        'opacity' : 1,
			  'top' : initTopCalc
      });
  } else if ($('#page-header-wrapper').length) {
      $('#header-text').css({'opacity' : 1});
  }
}
function pageHeaderTextScroll() {
  if (Foundation.MediaQuery.atLeast('medium') && $('#page-header-wrapper').length) {
    var pageHeaderHeight = $('#page-header-wrapper').height();
    var pageHeadingHeight = $('#header-text').height();
    var scrollTop = $(window).scrollTop();
    var opacityCalc = 1-(scrollTop/(pageHeaderHeight-($('#header-text').height()*2)+60));
    var topCalc = (scrollTop*0.50) + ((pageHeaderHeight/2)) - ((pageHeaderHeight/100)*10) +"px";
      if (scrollTop>0 && scrollTop<pageHeaderHeight && Foundation.MediaQuery.atLeast('mediumx')) {
      //  var BGScrollVal = scrollTop * 1.1; // To move down with scroll
        var BGScrollVal = Math.round(scrollTop); // To keep static with scroll
        var BGGRayscaleVal = ((scrollTop/pageHeaderHeight)*100)+10;
        //console.log('BGGRayscaleVal ' +BGGRayscaleVal);
        $('#page-header').css('transform', 'translateY(' + BGScrollVal + 'px)');
        $('#page-header').css('-webkit-transform', 'translateY(' + BGScrollVal + 'px)');
        $('#page-header').css('-webkit-filter', 'grayscale(' + BGGRayscaleVal + '%)');
        $('#page-header').css('filter', 'grayscale(' + BGGRayscaleVal + '%)');
      } else if (scrollTop==0) {
        $('#page-header').css('transform', 'translateY(0)');
        $('#page-header').css('-webkit-transform', 'translateY(0)');
        $('#page-header').css('-webkit-filter', 'grayscale(0)');
        $('#page-header').css('filter', 'grayscale(0)');
      }
    if ($('#header-text').css('opacity') >= 0) {
      $('#header-text').css({
        'opacity' : opacityCalc,
			  'top' : topCalc
      });
    }
  }
}


/***************** Hide Header Until Needed  ******************/

function hideHeaderUntilNeeded() {
  var headerResize = $('#header-outer').attr('data-header-resize');
  var headerHideUntilNeeded = $('body').attr('data-headed-needed');
  var logoDefaultSize = $('.logo-desktop').attr('data-default-height');
  if (Foundation.MediaQuery.atLeast('large') && $('#header-outer').length) {
    if (headerResize == 1 && headerHideUntilNeeded != '1') {
        //headerInit();
        $(window).off('scroll.headerResizeEffect');
        $(window).on('scroll.headerResizeEffect', smallNav);
    } else if (headerHideUntilNeeded != '1') {
        //headerInit();
        $(window).off('scroll.headerResizeEffectOpaque'); - $(window).on('scroll.headerResizeEffectOpaque', opaqueCheck);
    } else if (headerHideUntilNeeded == '1') {
        //headerInit();
        if ($('.nectar-box-roll').length > 0) $('#header-outer').addClass('at-top-before-box');
        var previousScroll = 0,
            menuOffset = $('#header-outer').height() * 2,
            detachPoint = ($('body.mobile').length > 0) ? 150 : 600,
            hideShowOffset = 6;

        function hhunCalcs(e) {
            if ($('body.animated-scrolling').length > 0 && $('#header-outer.detached').length > 0) return false;
            if ($('#header-outer[data-mobile-fixed="false"]').length > 0 && $('body.mobile').length > 0) {
                $('#header-outer').removeClass('detached');
                return false;
            }
            var currentScroll = $(this).scrollTop(),
                scrollDifference = Math.abs(currentScroll - previousScroll);
            if (!$('#header-outer').hasClass('side-widget-open') && !$('#header-outer .slide-out-widget-area-toggle a').hasClass('animating')) {
                if (currentScroll > menuOffset) {
                    if (currentScroll > detachPoint) {
                        if (!$('#header-outer').hasClass('detached'))
                            $('#header-outer').addClass('detached').removeClass('parallax-contained');
                            if (headerResize == 1) {
                              $('.logo-desktop').css('height',logoDefaultSize/2 + 'px');
                            }
                        if ($('#header-outer[data-permanent-transparent="1"]').length == 0) $('#header-outer').removeClass('transparent');
                    }
                    if (scrollDifference >= hideShowOffset) {
                        if (currentScroll > previousScroll) {

                            if (!$('#header-outer').hasClass('not-needed')) {
                                $('#header-outer').addClass('not-needed').removeClass('at-top');
                            }
                        } else {
                            if ($('#header-outer').hasClass('not-needed')) {
                              $('#header-outer').removeClass('not-needed');
                            }
                            $('.page-submenu.stuck').css('transform', 'translateY(' + $('#header-outer').outerHeight() + 'px)').removeClass('header-not-visible');
                        }
                    }
                } else {
                    $topDetachNum = ($('#header-outer[data-using-secondary="1"]').length > 0) ? 32 : 0;
                    if (currentScroll <= $topDetachNum) {
                        $('#header-outer').removeClass('detached').addClass('at-top');
                        if (headerResize == 1) {
                          $('.logo-desktop').css('height',logoDefaultSize + 'px');
                        }
                        if ($('#header-outer[data-transparent-header="true"]').length > 0 && $('.nectar-box-roll').length == 0) $('#header-outer').addClass('transparent').css('transform', 'translateY(0)');
                    }
                }
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    $('#header-outer').removeClass('not-needed');
                  //  $('.page-submenu.stuck').css('transform', 'translateY(' + $('#header-outer').outerHeight() + 'px)').removeClass('header-not-visible');
                }
            }
            previousScroll = currentScroll;
        }
        hhunCalcs();
        $(window).scroll(hhunCalcs);
    }
  }
}

/***************** Account Homepage Scroll ******************/

function accountHomeScroll() {
  if ($('body').hasClass('page-template-template-account-homepage')) {
    var scroll = $(window).scrollTop();
    if (scroll > 200) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  }
}

jQuery(document).ready(function($) {
  pageHeaderInit();
  remainingHeight();
  positionSearchBar();

  $('#search-header').on('off.zf.toggler',function() {
    setTimeout( function() {
      console.log('setting focus');
      $('#search-header').find('input').focus();
    },500);
  });
  $('#search-header').on('on.zf.toggler',function() {
    $('#search-header').find('input').blur();
  });
  //panelTopPadding();
  // On scroll
  $(window).scroll(function() {
  //  pageHeaderTextScroll();
    accountHomeScroll();
  });
  // On resize
	$(window).resize(function(){
    pageHeaderInit();
    remainingHeight();
    positionSearchBar();
  //  panelTopPadding();
    //Get new header height
    headerHeight = getHeaderHeight();
  });
});
